import { ILinkedObjectGroupSpecifiable } from "../../../../../../../documaker/domain/format/objects";
import { ObjectTargetsTranslator } from "./ObjectTargetsTranslator";
import { LinkedObjectGroupTranslator } from "./LinkedObjectGroupTranslator";

export class GroupAlertAllowBehaviorTranslator extends ObjectTargetsTranslator<ILinkedObjectGroupSpecifiable> {
  constructor() {
    super(
      "parent-alert",
      new LinkedObjectGroupTranslator({
        isItemBeanEnable: b => b["@item-type"] === "2",
        complementBean: b => b["@item-type"] = "2",
      }));
  }
}
